import { render, staticRenderFns } from "./content-social-icons.vue?vue&type=template&id=7fc7adcd&scoped=true"
import script from "./content-social-icons.vue?vue&type=script&lang=js"
export * from "./content-social-icons.vue?vue&type=script&lang=js"
import style0 from "./content-social-icons.vue?vue&type=style&index=0&id=7fc7adcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc7adcd",
  null
  
)

export default component.exports